<template>
  <div>
    <div
        id="carouselExampleControls"
        class="carousel slide carousel-fade"
        data-ride="carousel"
    >
      <ol class="carousel-indicators">
        <li
            data-target="#carouselExampleIndicators"
            data-slide-to="0"
            class="active"
        ></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
        <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
      </ol>
      <div class="carousel-inner">
        <div class="carousel-item active">
          <img
              class="d-block w-100 carousel-image"
              src="../assets/main_1_edited.jpg"
              alt="First slide"
          />
          <div class="carousel-caption">
            <h1>Penzion u Zdichynců</h1>
            <p>Hledáte ubytování na Šumavě?</p>
          </div>
        </div>
        <div class="carousel-item">
          <img
              class="d-block w-100 carousel-image"
              src="../assets/main_1_edited.jpg"
              alt="Second slide"
          />
          <div class="carousel-caption">
            <h1>Penzion u Zdichynců</h1>
            <p>Zážitková dovolená</p>
          </div>
        </div>
        <div class="carousel-item">
          <img
              class="d-block w-100 carousel-image"
              src="../assets/main_1_edited.jpg"
              alt="Second slide"
          />
          <div class="carousel-caption">
            <h1>Penzion u Zdichynců</h1>
            <p>Ubytování s tradicí</p>
          </div>
        </div>
      </div>
      <a
          class="carousel-control-prev"
          href="#carouselExampleControls"
          role="button"
          data-slide="prev"
      >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a
          class="carousel-control-next"
          href="#carouselExampleControls"
          role="button"
          data-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
    <div class="container pt-3">
      <div class="row mb-3">
        <div class="col-md-5">
          <div class="card col-12 mb-1">
            <div class="card-body">
              <h4 class="card-title">Rezervace</h4>
              <p class="card-text">
                <i class="fa fa-phone fa-2x"></i>
                <span style="font-weight: bold; font-size: 1.1em"
                ><a class="text-reset contact-link" href="tel:+420721299777">+420 721 299 777</a></span
                >
              </p>
              <p class="card-text">
                <i class="fa fa-envelope fa-2x"></i>
                <span style="font-weight: bold; font-size: 1.1em"
                ><a class="text-reset contact-link" href="mailto:uzdichyncu@seznam.cz">uzdichyncu@seznam.cz</a></span
                >
              </p>
            </div>
          </div>
          <div class="card col-12 mb-1">
            <div class="card-body">
              <h4 class="card-title">Kde nás najdete?</h4>
              <p class="card-text">Kubova Huť 36, 385 01 Vimperk</p>
            </div>
          </div>
        </div>
        <div class="col-md-7">
          <div class="card">
            <div class="card-body">
              <h3 class="card-title">O penzionu</h3>
              <p class="card-text">
                Penzion U Zdichynců se nachází v klidném prostředí centrální Šumavy pod jižním svahem Boubína v obci Kubova Huť
                v nadmořské výšce 1000 m. n. m. Kubova Huť je střediskem letní i zimní dovolené, dovolené s dostatkem atraktivních stezek pro
                cyklistiku a pěší turistiku, se dvěma sjezdovkami přímo v obci a upravovanými běžeckými tratěmi poblíž obce.
              </p>
              <p class="card-text">
                Na Kubově Huti se nachází nejvýše položená železniční stanice v Čechách (necelých 5 minut chůze od penzionu).
              </p>
              <p class="card-text">
                Kubova Huť je ideálním místem pro turistiku všeho druhu. Zážitkem je například zdolání vrcholu Boubína, kde se nachází rozhledna
                (vstup je zpoplatněn – 50,- Kč). Z rozhledny je možno přehlédnout podstatnou část jižních Čech, za hezkého počasí a ideální
                viditelnosti jsou vidět štíty Alp.
              </p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "home",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.carousel-image {
  min-height:350px;
  -o-object-fit:cover;
  object-fit:cover;
  overflow:hidden;
}

.contact-link {
  margin-left:5px;
}

.carousel-caption {
  top:50%;
  transform:translateY(-50%);
  bottom:initial;
}

</style>
